var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "#212121",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.396A2.609 2.609 0 005.396 8 2.609 2.609 0 008 10.604 2.609 2.609 0 0010.604 8 2.609 2.609 0 008 5.396zM15.809 8c0-1.078.01-2.147-.051-3.223-.06-1.25-.346-2.36-1.26-3.273-.916-.916-2.023-1.2-3.273-1.26-1.079-.06-2.147-.05-3.223-.05-1.078 0-2.147-.01-3.223.05-1.25.06-2.36.346-3.273 1.26C.59 2.42.306 3.527.246 4.777.186 5.855.196 6.924.196 8s-.01 2.146.05 3.223c.06 1.25.346 2.359 1.26 3.273.916.916 2.023 1.2 3.273 1.26 1.078.06 2.147.05 3.223.05 1.078 0 2.146.01 3.223-.05 1.25-.06 2.359-.346 3.273-1.26.916-.916 1.2-2.023 1.26-3.273.062-1.077.05-2.145.05-3.223zM8 12.006A4 4 0 013.994 8 4 4 0 018 3.994 4 4 0 0112.006 8 4 4 0 018 12.006zm4.17-7.24a.934.934 0 110-1.872.934.934 0 110 1.872z"
  })));
}

export default SvgInstagram;